import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import _ from 'lodash'
import moment from 'moment'
import Apis from '@/Apis/_'
// eslint-disable-next-line
import {
  AgendamentoCirurgia, AgendamentoGetAllQuery, IRequestMessage, TipoDocumentoUpload, Laudo,
  Medico, Situacao, ModalAgendamentoBackoffice, Solicitacao, NovaDataSolicitada, Acoes, EnvioConvite, TipoConviteEnum, Convite,
  Autorizacao, HeaderStatusFiltro, MedicoSolicitante, Snackbar, SolicitacaoCancelamento, AlteracaoDataMensagem, Convenio, ErrorMessage,
  ReservaHemocomponente, Hemocomponente, StatusAvaliacaoPreAnestesia, User, CadastroMedicoBackoffice, Lembrete, SecretariaDoMedicoSolicitante } from '@/types/_'
import { timeout, getUser } from '@/utils/common'

@Module({ namespaced: true, name: 'AgendamentoBackofficeStore' })
export default class AgendamentoBackofficeStore extends VuexModule {
  public user: User = { ...getUser() }

  public modalConvite: boolean = false

  private conviteDefault: EnvioConvite = {
    nome: '',
    cpf: '',
    email: '',
    tipo: TipoConviteEnum.MedicoAgendamento,
    hospitais: [],
  }

  private convitesDefault: any[] = []

  public convite: EnvioConvite = { ...this.conviteDefault }
  public convites: Convite[] = [...this.convitesDefault]

  private cadastroMedicoBackofficeDefault: CadastroMedicoBackoffice = {
    nome: '',
    cpf: '',
    emailPrincipal: '',
    emailsSecundarios: [],
    conselhoTipo: 'CRM',
    conselhoNumero: '',
    conselhoUf: '',
    cbos: [],
  }

  public cadastroMedicoBackoffice: CadastroMedicoBackoffice = { ...this.cadastroMedicoBackofficeDefault }

  public medicosCadastrados: any = []

  public listaConvites: boolean = false
  public listaMedicos: boolean = false
  public conviteSearch: string = ''
  public medicoSearch: string = ''
  public conviteTableHeaders: any[] = [
    { text: 'Nome', class: 'table-headers', align: 'left', value: 'nome' },
    { text: 'E-mail', class: 'table-headers', align: 'center', value: 'email' },
    { text: 'Status', class: 'table-headers', align: 'center', value: 'status.display' },
    { text: 'Ações', class: 'table-headers', align: 'center', sortable: false },
  ]

  public medicoTableHeaders: any[] = [
    { text: 'Nome do médico', class: 'table-headers', align: 'left', value: 'medicoLogin', sortable: false },
    { text: 'CPF do médico', class: 'table-headers', align: 'left', value: 'medicoCpf', sortable: false },
    { text: 'Login do médico', class: 'table-headers', align: 'center', value: 'medicoLogin', sortable: false },
    { text: 'Nome da secretária', class: 'table-headers', align: 'left', value: 'secretariaNome', sortable: false },
    { text: 'Login da secretária', class: 'table-headers', align: 'center', value: 'secretariaLogin', sortable: false },
    { text: 'E-mails', class: 'table-headers', align: 'center', value: 'emails', sortable: false },
  ]

  public conviteTableLoading: boolean = false

  public requestMessage: IRequestMessage = {
    avancar: {
      text: 'Carregando...',
    },
    continuarDepois: {
      text: 'Enviando...',
    },
    init: {
      text: 'Carregando...',
    },
    status: true,
    deleteMessage: 'Deletando...',
    post: 'Enviando...',
    update: 'Atualizando...',
    messageFinish: 'Solicitação enviada com sucesso!',
    errorApi: 'Houve um erro no envio dos dados.',
    errorUpload: '',
    search: 'Buscando...',
  }

  public modalAgendamentoBackoffice: ModalAgendamentoBackoffice = {
    triagem: false,
    novaDataSolicitada: false,
    pendencia: false,
    autorizarSolicitacao: false,
    confirmarCancelamento: false,
    lembrete: true,
  }

  public medicoSolicitante: MedicoSolicitante = {
    cpf: '',
    conselhoTipo: 'CRM',
    conselhoNumero: '',
    conselhoUf: '',
    email: '',
    especialidade: '',
    hospitais: [],
    id: '',
    medicoTemUsuario: false,
    nome: '',
    recebeEmailNotificacao: false,
    telefone: '',
    urlAssinatura: '',
  }

  public secretariaDoMedicoSolicitante: SecretariaDoMedicoSolicitante = {
    nome: '',
    telefone: '',
    email: '',
  }

  public solicitacaoDefault: Solicitacao = {
    etapa: {
      display: '',
      key: '',
    },
    id: '',
    observacaoReservaSala: null,
    nomePaciente: '',
    hospitalId: '',
    dataNascimento: null,
    dataNascimentoTemp: '',
    telefone: '',
    celular: '',
    email: '',
    convenio: null,
    plano: null,
    carteirinha: '',
    diagnosticoJustificativa: '',
    resultadosDeExames: null,
    tempoCirurgia: null,
    opcaoDataPrevisto1: null,
    opcaoDataPrevisto2: null,
    opcaoDataPrevisto3: null,
    opcaoDataPrevisto1Temp: '',
    opcaoDataPrevisto2Temp: '',
    opcaoDataPrevisto3Temp: '',
    instrucaoData: null,
    dataAgendamentoVirtual: false,
    dataAgendamento: '',
    instrucaoDataPrevista: '',
    especificarPrecaucoes: '',
    alergiaLatexTemp: '',
    alergiaLatex: null,
    alergiaContraste: null,
    testeCovid: null,
    marcapasso: null,
    reoperacao: null,
    especificarOutrasAlergias: null,
    carater: null,
    caraterTemp: null,
    files: [],
    laudos: [],
    resumos: [],
    cids: null,
    diaria: null,
    equipamentos: null,
    caixasCirurgicas: [],
    especificacaoExameIntraOperatorio: '',
    examesIntraOperatorios: {
      anatomiaPatologica: false,
      anatomiaPatologicaHospitalOuParticular: null,
      anatomiaPatologicaParticularLocal: null,
      biobanco: false,
      biopsia: false,
      biopsiaHospitalOuParticular: null,
      biopsiaParticularLocal: null,
      broncoscopiaFlexivel: false,
      catho: false,
      cellSaver: false,
      colangiografia: false,
      colangiopancreatografiaRetrograda: false,
      colonoscopia: false,
      congelacaoIPC: false,
      congelacaoMultipat: false,
      congelacaoPathos: false,
      congelacaoFerdinando: false,
      congelacaoSalomao: false,
      congelacaoLoccus: false,
      congelacaoFleury: false,
      congelacaoEinstein: false,
      congelacaoBML: false,
      congelacaoCIPAC: false,
      congelacaoPathology: false,
      dimen: false,
      ecocardiograma: false,
      ecointraoperatório: false,
      ecotransesofagico: false,
      endoscopia: false,
      escleraUnicamp: false,
      examesLaboratoriais: false,
      fivmed: false,
      insite: false,
      mamografia: false,
      medicinaNuclear: false,
      monitorizacaoNeurofisiologica: false,
      nervoNIM: false,
      neuronavegacao: false,
      outros: false,
      outrosEspecificar: null,
      potencialEvocado: false,
      pth: false,
      radioterapia: false,
      ressonancia: false,
      rxScopia: false,
      semExameIntraoperatorio: false,
      tipagemSanguinea: false,
      tomografia: false,
      tomografiaParaEstereotaxia: false,
      transporte: false,
      udo: false,
      ultrassonografiaDeImagem: false,
      ultrassonografiaIntraoperatoria: false,
      ultrassonografiaIntraoperatoriaEquipeDoHospital: null,
      ultrassonografiaLaparoscopio: false,
      ultrassonografiaRadiologia: false,
      ultrassonografiaRadiologiaAcompanhamento: false,
    },
    honorarioMedico: null,
    honorarioMedicoTemp: null,
    honorarioMedicoDocumento: null,
    idade: null,
    lateralidade: null,
    medicoSolicitanteId: '',
    opmes: null,
    orientacaoPreparoPaciente: '',
    precaucoesTemp: null,
    precaucoes: null,
    procedimento: {
      codigo: '',
      descricao: '',
      historicoMedico: false,
      id: '',
      porte: '',
      procedimentoPrincipal: false,
      quantidade: 0,
      quantidadeAutorizada: 0,
      particular: false,
    },
    procedimentosAssociados: null,
    reservaHemocomponentes: {
      concentradoHemacias: {
        quantidade: null,
        value: false,
      },
      concentradoPlaquetas: {
        quantidade: null,
        value: false,
      },
      crioprecipitado: {
        quantidade: null,
        value: false,
      },
      plasmaFrescoCongelado: {
        quantidade: null,
        value: false,
      },
      tipagemSanguinea: {
        value: false,
      },
      tipagemSanguineaABORHPAI: {
        quantidade: null,
        value: false,
      },
      semReserva: {
        quantidade: null,
        value: false,
      },
    },
    reservaUTI: {
      display: '',
      key: '',
    },
    reservaUtiTemp: null,
    anestesiaDoHospital: null,
    anestesiaDoHospitalTemp: '',
    honorarioAnestesista: null,
    honorarioAnestesistaDocumento: null,
    tipoProcedimento: null,
    tipoInternacao: null,
    lateralidadeTemp: null,
    tipoProcedimentoTemp: null,
    temMedicamentosEspeciais: null,
    temMedicacaoContinua: null,
    medicamentosEspeciais: '',
    medicacaoContinua: '',
    medEspeciaisTemp: '',
    temPrevisaoUsoQuimioterapico: null,
    usoQuimioTemp: '',
    previsaoUsoQuimioterapico: null,
    recemNascido: null,
    recemNascidoTemp: null,
    sexo: '',
    statusSituacao: '',
    codigoPrestador: '',
    medicoSolicitante: this.medicoSolicitante,
    secretariaDoMedicoSolicitante: this.secretariaDoMedicoSolicitante,
    anestesistaCrm: '',
    nomeAnestesista: '',
    anestesista: null,
    numeroAgendamento: '',
    protocoloOPME: '',
    protocoloOperadora: '',
    autorizacaoValidade: '',
    dataAutorizacaoNaOperadora: '',
    autorizadoStatus: null,
    observacao: '',
    autorizacaoObservacao: '',
    situacao: {
      display: '',
      key: '',
    },
    acoes: {
      editar: false,
      podeResolverPendencia: false,
      aceitarAutorizacaoParcial: false,
      criarContestacao: false,
      responderContestacao: false,
      solicitarCancelamento: false,
      visualizarContestacao: false,
      visualizarItensAutorizados: false,
      agendamentoConfirmaCancelamento: false,
      agendamentoFazCancelamento: false,
      agendamentoAtualizaTriagem: false,
      alterarData: false,
      analizarResposta: false,
      autorizacaoFazCotacao: false,
      autorizacaoAutorizar: false,
      autorizacaoFazAnalisePreAutorizacao: false,
      autorizacaoFazAnalisePreAutorizacaoUrgencia: false,
      autorizacaoFazAnalisePreCotacao: false,
      autorizacaoEvoluiAguardandoPrazoPosTriagem: false,
      confirmarData: false,
      contatar: false,
      agendamentoRealizaTriagem: false,
      visualizar: false,
      visualizarPendencia: false,
      anestesistaFazAvaliacao: false,
      autorizacaoAlteraCotacao: false,
      autorizacaoFazAnalisePosCotacao: false,
      autorizacaoResolvePendenciaRoboAutorizacao: false,
      autorizacaoFazRetornoParaCotacao: false,
      autorizacaoAutorizaNegociacaoParticular: false,
      agendamentoFazReservaDeSalaParticular: false,
      agendamentoInformaReservaEmSolicitacaoParticular: false,
    },
    cotacaoOperadorasExtraGrupo: {
      faturamentoDiretoComOperadora: false,
      notaFiscal: false,
      observacao: 'Outros',
      valor: null,
      cotacaoComUrgencia: false,
      dataReferenciaParaOperadora: '',
    },
    hospitalRealizaCotacao: null,
    canceladoMotivo: {
      display: '',
      key: '',
    },
    elegivel: null,
    dataVerificacaoElegibilidade: null,
    erroVerificacaoElegibilidade: null,
    observacaoPreAnestesia: '',
    outrasAlergias: null,
    tipoAnestesia: '',
    tipoAnestesiaPaciente: '',
    viasAereasDificilAcesso: null,
    preAnestesico: null,
    statusAvaliacaoPreAnestesia: {
      display: '',
      key: '',
    },
    pacienteAptoParaAnestesia: null,
    medicoAnestesistaPreAvaliacaoNome: '',
    tipoAnestesiaTemp: null,
    origem: null,
    enviadaPor: null,
    outrosTipoAnestesia: null,
    pacienteUsaMarcaPasso: null,
    auditada: false,
    auditadaObservacao: '',
    salaCirurgicaNome: '',
    hospitalFazReservaDeSala: false,
    opmeFornecedores: [],
    statusAguardandoOperadora: '',
    negociacaoParticularStatus: null,
    numeroOrcamento: null,
    localAtendimentoId: null,
    localAtendimentoNome: null,
    grupoOpmeDaSolicitacao: [],
    cpf: '',
    pacienteNome: '',
    url: '',
    paciente: {
      carteirinha: '',
      celular: '',
      convenioId: '',
      convenioNome: '',
      cpf: '',
      rgh: '',
      dataNascimento: '',
      dataVerificacaoElegibilidade: '',
      elegivel: '',
      email: '',
      id: '',
      idade: '',
      nome: '',
      planoId: '',
      planoNome: '',
      categoriaId: '',
      categoriaNome: '',
      tipoAcomodacao: '',
      recemNascido: '',
      sexo: '',
      telefone: '',
      peso: '',
      altura: '',
    },
    historicoFamiliarHipertemiaMaligna: null,
    classificacaoAsa: null,
    observacaoComplementares: null,
    hospitalTemStepNaAutorizacaoParaAtualizarQuantidadeAutorizada: false,
    temInternacaoDeVespera: '',
    internacaoDeVespera: '',
    temReservaHemocomponentesSimples: null,
    pesoDoPaciente: null,
    tempoDeDoenca: null,
    farmacia: null,
    procedimentosInternacao: [],
    hospitalInsereProcedimentosDeInternacao: false,
    autorizacaoDeveInformarProtocoloDaOperadora: false,
    convenioExigeCodificacaoOpme: false,
    configuracaoOpme: {
      codificacaoDeOpmeEhObrigatorio: false,
      fazCodificacaoDeOpme: false,
      precificaValorUnitario: false,
      precificacaoValorUnitarioEhObrigatorio: false,
    },
    registraProtocoloDeRecuperacaoPrecoce: null,
    dadosGestacionais: {
      idadeGestacional: null,
      gemelar: null,
    },
  }

  private errorMessageDefault: ErrorMessage = {
    errorTipoAnestesiaPaciente: '',
    success: false,
    total: 0,
    errorAlergiaLatex: '',
    errorOutrasAlergias: '',
    errorviasAereasDificilAcesso: '',
    errorCarater: '',
    errorCarteirinha: '',
    errorCelular: '',
    errorCids: '',
    errorConcentradoHemaciasQnt: '',
    errorConcentradoPlaquetasQnt: '',
    errorConvenio: '',
    errorCrioprecipitadoQnt: '',
    errorDataNascimento: '',
    errorDataPrevista1: '',
    errorDataPrevista2: '',
    errorDataPrevista3: '',
    errorDiagnosticoJustificativa: '',
    errorDiarias: '',
    errorEmail: '',
    errorEquipamento: '',
    errorEspecificacaoExameIntraOperatorio: '',
    errorEspecificarAlergia: '',
    errorEspecificarPrecaucoes: '',
    errorHonorarioMedico: '',
    errorLateralidade: '',
    errorOPME: '',
    errorOpmeFornecedor1: '',
    errorOpmeQuantidade: '',
    errorPaciente: '',
    errorPlano: '',
    errorPlasmaFrescoCongeladoQnt: '',
    errorPrecaucoes: '',
    errorProcedimento: '',
    errorReservaHemocomponentes: '',
    errorReservaUti: '',
    errorTelefone: '',
    errorTempoCirurgia: '',
    errorTipoProcedimento: '',
    errorMedicamentosEspeciaisDescricao: '',
    errorPrevisaoUsoQuimioterapicoDescricao: '',
    errorAnestesistaHospital: '',
    errorMedicamentosEspeciais: '',
    errorQuimioterapico: '',
    errorRecemNascido: '',
    errorSexo: '',
    errorEquipeDoHospital: '',
    errorTipoAnestesia: '',
  }

  public errorMessage = { ...this.errorMessageDefault }

  public solicitacao: Solicitacao = { ...this.solicitacaoDefault }

  private conveniosDefault: Convenio[] = []

  public convenios: Convenio[] = [...this.conveniosDefault]

  public preAnestesiaStatus: any[] = [
    { nome: 'Pendente', status: 'Pendente' },
    { nome: 'Apto', status: 'Apto' },
    { nome: 'Apto com atenção', status: 'AptoComAtencao' },
    { nome: 'Não apto', status: 'NaoApto' },
  ]

  private paginaDefault: number = 1
  private qtdPorPaginaDefault: number = 25

  public pagina: number = this.paginaDefault
  public qtdPorPagina: number = this.qtdPorPaginaDefault
  public totalSolicitacoes: number = 0

  public cotacaoOperadorasExtraGrupoDefault = {
    faturamentoDiretoComOperadora: false,
    notaFiscal: false,
    observacao: 'Outros',
    valor: null,
    cotacaoComUrgencia: false,
    dataReferenciaParaOperadora: '',
  }

  public novaDataSolicitadaDefault: NovaDataSolicitada = {
    dataAgendamento: null,
    dataAgendamentoVirtual: false,
    solicitacaoId: '',
    opcaoDataPrevisto1: '',
    opcaoDataPrevisto2: '',
    opcaoDataPrevisto3: '',
    opcao: 0,
    data: '',
    hora: '',
    alterarData: false,
    numeroAgendamento: '',
  }

  public acoes: Acoes = {
    alterarData: false,
    analizarResposta: false,
    confirmarData: false,
    contatar: false,
    agendamentoRealizaTriagem: false,
    agendamentoAtualizaTriagem: false,
    visualizar: false,
    autorizacaoFazCotacao: false,
    autorizacaoAutorizar: false,
    autorizacaoFazAnalisePreAutorizacao: false,
    autorizacaoFazAnalisePreAutorizacaoUrgencia: false,
    autorizacaoFazAnalisePreCotacao: false,
    agendamentoConfirmaCancelamento: false,
    autorizacaoAlteraSolicitacaoAutorizada: false,
    autorizacaoEvoluiAguardandoPrazoPosTriagem: false,
    visualizarPendencia: false,
    agendamentoFazCancelamento: false,
    autorizacaoSolicitaCancelamento: false,
    anestesistaFazAvaliacao: false,
    autorizacaoAlteraCotacao: false,
  }

  public agendamentoCirurgia: AgendamentoCirurgia = {
    acoes: {
      alterarData: false,
      analizarResposta: false,
      confirmarData: false,
      contatar: false,
      agendamentoRealizaTriagem: false,
      agendamentoAtualizaTriagem: false,
      visualizar: false,
      autorizacaoFazCotacao: false,
      autorizacaoAutorizar: false,
      autorizacaoFazAnalisePreAutorizacao: false,
      autorizacaoFazAnalisePreAutorizacaoUrgencia: false,
      autorizacaoFazAnalisePreCotacao: false,
      autorizacaoAlteraSolicitacaoAutorizada: false,
      autorizacaoEvoluiAguardandoPrazoPosTriagem: false,
      agendamentoConfirmaCancelamento: false,
      visualizarPendencia: false,
      agendamentoFazCancelamento: false,
      autorizacaoSolicitaCancelamento: false,
      anestesistaFazAvaliacao: false,
      autorizacaoAlteraCotacao: false,
    },
    carater: '',
    convenioId: '',
    convenioNome: '',
    dataAgendamento: '',
    dataAgendamentoVirtual: false,
    dataNascimento: '',
    dataProximoContato: '',
    dataSolicitacao: '',
    etapa: {
      display: '',
      key: '',
    },
    hospitalId: '',
    hospitalNome: '',
    id: '',
    medicoId: '',
    medicoNome: '',
    opcaoDataPrevisto1: '',
    opcaoDataPrevisto2: '',
    opcaoDataPrevisto3: '',
    opme: '',
    pacienteNome: '',
    procedimentoPrincipalNome: '',
    situacao: {
      display: '',
      key: '',
      quantidade: 0,
    },
    situacaoData: '',
    numeroAgendamento: '',
    tempoNoStatus: '',
    lembreteStatus: '',
  }

  public autorizacao: Autorizacao = {
    solicitacaoId: '',
  }

  public headerStatusFiltroDefault: HeaderStatusFiltro = {
    enviado: true,
    emAutorizacao: true,
    autorizada: false,
    contato: false,
    novaDataSolicitada: false,
    pendenciaRespondida: false,
    pendente: false,
    aguardandoOperadora: false,
    emCotacao: false,
    autorizadaParcial: false,
    autorizadaAceitaMedico: false,
    contestacaoMedica: false,
    contestacaoPendente: false,
    cancelada: false,
    cancelamentoSolicitado: false,
    avalicacaoPendente: false,
    avalicacaoAvaliada: false,
    apto: false,
    naoApto: false,
    comAtencaoApto: false,
  }

  public snackbar: Snackbar = {
    disabled: false,
    disabledBtn: false,
    message: '',
    show: false,
    timeout: 3000,
  }

  public reservaHemocomponentes: ReservaHemocomponente = {
    concentradoHemacias: {
      quantidade: 0,
      value: false,
    },
    concentradoPlaquetas: {
      quantidade: 0,
      value: false,
    },
    crioprecipitado: {
      quantidade: 0,
      value: false,
    },
    plasmaFrescoCongelado: {
      quantidade: 0,
      value: false,
    },
    tipagemSanguinea: {
      value: false,
    },
    tipagemSanguineaABORHPAI: {
      quantidade: 0,
      value: false,
    },
    semReserva: {
      quantidade: 0,
      value: false,
    },
  }

  private lembreteDefault: Lembrete = {
    dataLembrete: null,
  }

  public lembrete: Lembrete = { ...this.lembreteDefault }

  public headerStatusFiltro: HeaderStatusFiltro = { ...this.headerStatusFiltroDefault }
  public scrollY: number = 0
  public medicoId: string = ''
  public paciente: string = ''
  public convenioFiltro: string[] = []
  public preAnestesiaFiltro: string = ''
  public opmeFiltro: boolean | string = false
  public novaDataSolicitadaFiltro: boolean = false
  public dataVirtualFiltro: boolean = false
  public numeroAgendamento: string = ''
  public ordenadoPorId: string = 'DataUltimaInteracaoAsc'
  public etapaQuery: string = ''
  public situacaoQuery: string[] = this.user.profile.roles.includes('backofficePreAnestesico') ? [] : ['enviado']
  public statusAvaliacaoPreAnestesiaQuery: string[] = []
  public data: string[] = []
  public medicos: Medico[] = []
  public ordenadoPor: any = [
    { id: 'DataUltimaInteracaoAsc', value: 'Tempo de ação mais antigo' },
    { id: 'DataUltimaInteracaoDesc', value: 'Tempo de ação mais recente' },
    { id: 'DataDoEnvioAsc', value: 'Data de envio mais antigo' },
    { id: 'DataDoEnvioDesc', value: 'Data de envio mais recente' },
    { id: 'AutorizacaoValidadeAsc', value: 'Data de validade mais antiga' },
    { id: 'AutorizacaoValidadeDesc', value: 'Data de validade mais recente' },
    { id: 'ProximasCirurgias', value: 'Próximas cirurgias' },
  ]

  public agendamentosCirurgia: AgendamentoCirurgia[] = []
  public situacoes: Situacao[] = []
  public statusAvaliacaoPreAnestesia: StatusAvaliacaoPreAnestesia[] = []
  public visualizarTriagem: boolean = false
  public novaDataSolicitada: NovaDataSolicitada = { ...this.novaDataSolicitadaDefault }
  public bloquearSolicitacao: boolean = false

  public solicitacaoCancelada: SolicitacaoCancelamento = {
    solicitacaoId: '',
  }

  private alteracaoDataAgendamentoMensagensDefault: AlteracaoDataMensagem[] = []

  public alteracaoDataAgendamentoMensagens: AlteracaoDataMensagem[] = { ...this.alteracaoDataAgendamentoMensagensDefault }

  get segueOProtocoloStatus() {
    return this.solicitacao.protocoloDeCirurgia && this.solicitacao.protocoloDeCirurgia.segueOProtocolo
  }

  get canShowManualSyncronizationHisAlert() {
    return this.solicitacao.naoSeraSincronizadaNoHisPorqueFoiCriadaAntesDoGoLive
  }

  @Action
  forceCast<T>(obj: any) {
    return obj
  }

  @Action({ commit: 'setAgendamentosMedico' })
  async loadAgendamentosMedicoSearch() {
    this.context.commit('setSituacoes', [])

    const param: AgendamentoGetAllQuery = {
      usuarioId: this.user.profile.sub,
      medicoId: this.medicoId,
      paciente: this.paciente,
      etapa: this.etapaQuery,
      situacao: this.situacaoQuery,
      statusAvaliacaoPreAnestesiaQuery: this.statusAvaliacaoPreAnestesiaQuery,
      data: this.data,
      dataAgendamentoVirtual: this.dataVirtualFiltro,
      orderBy: this.ordenadoPorId,
      convenioNome: this.convenioFiltro,
      preanestesia: this.preAnestesiaFiltro,
      numeroAgendamento: this.numeroAgendamento,
      pagina: this.pagina,
      qtdPorPagina: this.qtdPorPagina,
      opme: this.opmeFiltro,
    }

    const request = await Apis.Agendamento
      .AgendamentoMedicoBackofficeApi.getAllSearch(param)
    if (request.success) {
      const situacoesResult = request.data.situacoes

      this.context.commit('setSituacoes', situacoesResult)
      this.context.commit('setTotalSolicitacoes', request.data.totalSolicitacoes)
      this.context.commit('setStatusAvaliacaoPreAnestesia', request.data.statusAvaliacaoPreAnestesia)
      return request.data.solicitacoes
    }

    return []
  }

  @Action({ commit: 'setSolicitacao' })
  async getSolicitacaoById(solicitacaoId: string) {
    const request = await Apis.Agendamento
      .AgendamentoMedicoBackofficeApi.getEtapaSolicitacaoById(solicitacaoId)
    if (request.success) {
      const solicitacaoCast = request.data
      solicitacaoCast.nomePaciente = request.data.pacienteNome
      if (solicitacaoCast.hospitalRealizaCotacao && !solicitacaoCast.cotacaoOperadorasExtraGrupo) {
        solicitacaoCast.cotacaoOperadorasExtraGrupo = { ...this.cotacaoOperadorasExtraGrupoDefault }
      }

      if ([undefined, null].includes(solicitacaoCast.auditada)) {
        solicitacaoCast.auditada = false
        solicitacaoCast.auditadaObservacao = ''
      }

      this.context.commit('setAcoes', request.data.acoes)
      return solicitacaoCast
    }
    return {}
  }

  @Action({ commit: 'setConvenios' })
  async getAllConvenios() {
    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getAllConveniosByUsuarioHospitalLogado()
    if (request.success) {
      return request.data
    }
    return []
  }

  @Action({ commit: 'setMedicos' })
  async loadAMedicos() {
    const usuarioId = this.user.profile.sub

    const request = await Apis.Agendamento
      .AgendamentoMedicoBackofficeApi.getAllMedicoByUsuarioId(usuarioId)
    if (request.success) {
      return request.data
    }
    return []
  }

  @Action({ commit: 'setMedicoAssistentes' })
  async loadMedicoAssistentesAll() {
    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.medicoAssistentesAll()

    if (request.success) {
      return request.data
    }
    return []
  }

  @Action({ commit: 'setSolicitacao' })
  async LoadSolicitacaoById(solicitacaoId: string) {
    const request = await Apis.Agendamento
      .AgendamentoMedicoBackofficeApi.getEtapaSolicitacaoById(solicitacaoId)
    if (request.success) {
      const solicitacaoCast = request.data
      solicitacaoCast.nomePaciente = request.data.pacienteNome
      if (!solicitacaoCast.cotacaoOperadorasExtraGrupo) {
        solicitacaoCast.cotacaoOperadorasExtraGrupo = null
      }
      this.context.commit('setAcoes', request.data.acoes)
      this.context.dispatch('loadNovaDataAgendamentoCirurgia', solicitacaoCast)

      const tipoArray: any[] = []
      solicitacaoCast.tipoAnestesia.map((c) => {
        if (c.outrosTipoAnestesia) {
          solicitacaoCast.outrosTipoAnestesia = c.outrosTipoAnestesia
        }
        tipoArray.push(c.tipo.key)
        return c
      })

      if ([undefined, null].includes(solicitacaoCast.auditada)) {
        solicitacaoCast.auditada = false
        solicitacaoCast.auditadaObservacao = ''
      }

      solicitacaoCast.tipoAnestesiaTemp = tipoArray
      return solicitacaoCast
    }
    return {}
  }

  @Action
  async putNovaDataSolicitacao() {
    const { solicitacaoId } = this.novaDataSolicitada
    const { novaDataSolicitada } = this

    const request = await Apis.Agendamento
      .AgendamentoMedicoBackofficeApi.putNovaDataSolicitacao(solicitacaoId, novaDataSolicitada)
    return request.success
  }

  @Action
  async solicitacaoAuditada(params: any) {
    const request = await Apis.Agendamento
      .AgendamentoMedicoBackofficeApi.solicitacaoAuditada(params)
    return request.success
  }

  @Action
  async getCheckNumeroReserva(params: any) {
    const request = await Apis.Agendamento
      .AgendamentoMedicoBackofficeApi.getCheckNumeroReserva(params.solicitacaoId, params.hospitalId, params.numeroReserva)

    return request.data
  }

  @Action
  async putAutorizacao(solicitacaoId: string) {
    const request = await Apis.Agendamento
      .AgendamentoMedicoBackofficeApi.putAutoriza(solicitacaoId)
    return request.success
  }

  @Action
  async backofficeAgendamentoRealizaTriagem(params: any) {
    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.backofficeAgendamentoRealizaTriagem(params.solicitacaoId, params)
    return request.success
  }

  @Action
  async bloquearAgendamento(solicitacaoId: string) {
    const request = await Apis.Agendamento
      .AgendamentoMedicoBackofficeApi.bloquearAgendamento(solicitacaoId)

    if (request.success) {
      this.context.commit('setBloquearSolicitacao', true)
    }

    return request
  }

  @Action
  async desbloquearAgendamento(solicitacaoId: string) {
    const request = await Apis.Agendamento
      .AgendamentoMedicoBackofficeApi.desbloquearAgendamento(solicitacaoId)

    if (request.success) {
      this.context.commit('setBloquearSolicitacao', false)
    }

    return request
  }

  @Action({ commit: 'setLaudos' })
  async loadLaudos() {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.getAllLaudos(this.solicitacao.id, TipoDocumentoUpload.Laudo)
    if (request.success) {
      const laudosCast = await this.forceCast<Laudo[]>(request.data)
      return laudosCast
    }
    return []
  }

  @Action
  async uploadLaudo(formData: any) {
    const solicitacaoId = this.solicitacao.id
    const headers: any = {
      'Content-Type': 'multipart/form-data',
    }
    const request = Apis.Agendamento.SolicitacaoCirurgiaApi.upload(formData, TipoDocumentoUpload.Laudo, headers, solicitacaoId)
    if (request.success) {
      const laudosCast = await this.forceCast<Laudo>(request.data)
      this.context.commit('setLaudos', laudosCast)
    }
    return request
  }

  @Action
  async deleteLaudo(hospitalId: string, id: string) {
    const request = await Apis.Agendamento.SolicitacaoCirurgiaApi.deleteLaudoById(hospitalId, id)
    if (request.success) {
      this.context.commit('deleteLaudoById', id)
    }
    return request
  }

  @Action({ commit: 'fillHemocomponentes' })
  async getReservaHemocomponente() {
    const solicitacaoId = this.solicitacao.id
    const request = await Apis.Agendamento
      .SolicitacaoCirurgiaApi.getAllReservaHemocomponentes(solicitacaoId)

    if (request.success) {
      return request.data
    }

    return []
  }

  @Action({ commit: 'setConvites' })
  async getConvites() {
    const hospitalResponse = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getHospitalCurrentUser()
    const hospitais = _.map(hospitalResponse.data, 'id')
    const request = await Apis.Cadastro.CadastroApi.getConvitesAll(hospitais)
    if (request.success) this.context.commit('setListaConvites', true)
    return request.data
  }

  @Action
  async sendCadastroMedico(cadastroMedico: CadastroMedicoBackoffice) {
    let request: any
    const cdMedico = cadastroMedico
    cdMedico.nome = cdMedico.nome.replace(/\s{2,}/g, ' ')
    try {
      request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.cadastrarMedicoBackoffice(cdMedico)
    } catch (e) {
      return e
    }

    return request
  }

  @Action
  async sendConvite() {
    let request: any
    const param = this.convite
    param.nome = param.nome.replace(/\s{2,}/g, ' ')
    const hospitalResponse = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getHospitalCurrentUser()
    param.hospitais = _.map(hospitalResponse.data, 'id')

    try {
      request = await Apis.Cadastro.CadastroApi.sendConvite(param)
      this.setConviteTableLoading(true)
      await timeout(700)
      await this.context.dispatch('getConvites')
      this.setConviteTableLoading(false)
    } catch (e) {
      return e
    }

    return request
  }

  @Action
  async resendConvite(conviteId: string) {
    let request: any

    try {
      request = await Apis.Cadastro.CadastroApi.resendConvite(conviteId)
      this.setConviteTableLoading(true)
      await timeout(700)
      await this.context.dispatch('getConvites')
      this.setConviteTableLoading(false)
    } catch (e) {
      return e
    }

    return request
  }

  @Mutation
  setListaConvites(value: boolean) {
    this.listaConvites = value
  }

  @Mutation
  setListaMedicos(value: boolean) {
    this.listaMedicos = value
  }

  @Mutation
  setUser(value: User) {
    this.user = value
  }

  @Mutation
  fillHemocomponentes(hemocomponentes: Hemocomponente[]) {
    hemocomponentes.map((c: Hemocomponente) => {
      switch (_.toUpper(c.tipo)) {
        case 'CONCENTRADOHEMACIAS':
          this.reservaHemocomponentes.concentradoHemacias.quantidade = c.quantidade
          this.reservaHemocomponentes.concentradoHemacias.value = true
          break
        case 'CONCENTRADOPLAQUETAS':
          this.reservaHemocomponentes.concentradoPlaquetas.quantidade = c.quantidade
          this.reservaHemocomponentes.concentradoPlaquetas.value = true
          break
        case 'CRIOPRECIPITADO':
          this.reservaHemocomponentes.crioprecipitado.quantidade = c.quantidade
          this.reservaHemocomponentes.crioprecipitado.value = true
          break
        case 'PLASMAFRESCOCONGELADO':
          this.reservaHemocomponentes.plasmaFrescoCongelado.quantidade = c.quantidade
          this.reservaHemocomponentes.plasmaFrescoCongelado.value = true
          break
        case 'TIPAGEMSANGUINEAABORHPAI':
          this.reservaHemocomponentes.tipagemSanguineaABORHPAI.quantidade = c.quantidade
          this.reservaHemocomponentes.tipagemSanguineaABORHPAI.value = true
          break
        case 'SEMRESERVA':
          this.reservaHemocomponentes.semReserva.quantidade = c.quantidade
          this.reservaHemocomponentes.semReserva.value = true
          break
        default:
          break
      }

      return c
    })
  }

  @Mutation
  deleteLaudoById(id: string) {
    const removeArray: any[] = []
    for (let i = 0; i < this.solicitacao.laudos.length; i++) {
      if (this.solicitacao.laudos[i].id === id) {
        removeArray.push(i)
      }
    }
    for (let i = 0; i < removeArray.length; i++) {
      this.solicitacao.laudos.splice(removeArray[i], 1)
    }
  }

  @Mutation
  setLaudos(value: any) {
    if (value) {
      if (!this.solicitacao.laudos) {
        this.solicitacao.laudos = []
      }
      this.solicitacao.laudos.push(value)
    }
  }

  @Mutation
  setConviteTableLoading(value: boolean) {
    this.conviteTableLoading = value
  }

  @Mutation
  setConvite(value: EnvioConvite) {
    this.convite = value
  }

  @Mutation
  clearConvite() {
    this.convite = { ...this.conviteDefault }
  }

  @Mutation
  setConvites(value: Convite[]) {
    this.convites = value
  }

  @Mutation
  clearConvites() {
    this.convites = [...this.convitesDefault]
  }


  @Mutation
  setConviteSearch(value: string) {
    this.conviteSearch = value
  }

  @Mutation
  clearConviteSearch() {
    this.conviteSearch = ''
  }

  @Mutation
  setMedicoSearch(value: string) {
    this.medicoSearch = value
  }

  @Mutation
  clearMedicoSearch() {
    this.medicoSearch = ''
  }

  @Mutation
  setBloquearSolicitacao(value: boolean) {
    this.bloquearSolicitacao = value
  }

  @Mutation
  setSnackbar(value: Snackbar) {
    this.snackbar = value
  }

  @Mutation
  async setShowModalConfirmarCancelamento(value: boolean) {
    this.modalAgendamentoBackoffice.confirmarCancelamento = value
  }

  @Mutation
  setShowModalTriagem(value: boolean) {
    this.modalAgendamentoBackoffice.triagem = value
  }

  @Mutation
  setShowModalLembrete(value: boolean) {
    this.modalAgendamentoBackoffice.lembrete = value
  }

  @Mutation
  setShowModalPendencia(value: boolean) {
    this.modalAgendamentoBackoffice.pendencia = value
  }

  @Mutation
  setShowModalNovaDataSolicitada(value: boolean) {
    this.modalAgendamentoBackoffice.novaDataSolicitada = value
  }

  @Mutation
  setShowModalConvite(value: boolean) {
    this.modalConvite = value
  }

  @Mutation
  setShowModalAutorizarSolicitacao(value: boolean) {
    this.modalAgendamentoBackoffice.autorizarSolicitacao = value
  }

  @Mutation
  setAutorizacao(value: Autorizacao) {
    this.autorizacao = value
  }

  @Mutation
  setAgendamentoCirurgia(value: AgendamentoCirurgia) {
    this.agendamentoCirurgia = value
  }

  @Action
  loadNovaDataAgendamentoCirurgia(agendamentoCirurgia: AgendamentoCirurgia) {
    this.context.commit('setNovaDataAgendamentoCirurgia', agendamentoCirurgia)
    this.context.commit('setloadDataAgendamento')
  }

  @Action
  loadNovaDataAgendamentoSolicitacao(solicitacao: Solicitacao) {
    this.context.commit('setNovaDataAgendamentoSolicitacao', solicitacao)
    this.context.commit('setloadDataAgendamento')
  }

  @Action
  dataAgendamentoRadioGroup() {
    const { opcao } = this.novaDataSolicitada
    const dataSelecionada = this.novaDataSolicitada[`opcaoDataPrevisto${opcao}`]
    this.context.commit('setNovaDataSolicitadaSelect', dataSelecionada)
  }

  @Action
  async atualizarTriagem() {
    const request = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.atualizarTriagem(this.solicitacao.id)
    if (request.success) {
      return request.data
    }
    return false
  }

  @Mutation
  setSolicitacaoCancelada(solicitacao: SolicitacaoCancelamento) {
    this.solicitacaoCancelada = solicitacao
  }

  @Mutation
  setNovaDataAgendamentoCirurgia(agendamentoCirurgia: AgendamentoCirurgia) {
    this.novaDataSolicitada.solicitacaoId = agendamentoCirurgia.id
    this.novaDataSolicitada.dataAgendamento = agendamentoCirurgia.dataAgendamento
    this.novaDataSolicitada.dataAgendamentoVirtual = agendamentoCirurgia.dataAgendamentoVirtual
    this.novaDataSolicitada.opcaoDataPrevisto1 = agendamentoCirurgia.opcaoDataPrevisto1
    this.novaDataSolicitada.opcaoDataPrevisto2 = agendamentoCirurgia.opcaoDataPrevisto2
    this.novaDataSolicitada.opcaoDataPrevisto3 = agendamentoCirurgia.opcaoDataPrevisto3
    this.novaDataSolicitada.numeroAgendamento = agendamentoCirurgia.numeroAgendamento
    this.acoes = agendamentoCirurgia.acoes
  }

  @Mutation
  setNovaDataAgendamentoSolicitacao(solicitacao: Solicitacao) {
    this.novaDataSolicitada.solicitacaoId = solicitacao.id
    this.novaDataSolicitada.dataAgendamento = solicitacao.dataAgendamento
    this.novaDataSolicitada.numeroAgendamento = solicitacao.numeroAgendamento
    this.novaDataSolicitada.dataAgendamentoVirtual = solicitacao
      .dataAgendamentoVirtual || false
    this.novaDataSolicitada.opcaoDataPrevisto1 = solicitacao.opcaoDataPrevisto1 || ''
    this.novaDataSolicitada.opcaoDataPrevisto2 = solicitacao.opcaoDataPrevisto2 || ''
    this.novaDataSolicitada.opcaoDataPrevisto3 = solicitacao.opcaoDataPrevisto3 || ''
  }

  @Mutation
  setloadDataAgendamento() {
    if (this.novaDataSolicitada.dataAgendamento) {
      this.novaDataSolicitada.opcao = 0
      this.novaDataSolicitada.data = moment(this.novaDataSolicitada.dataAgendamento).format('DDMMYYYY')
      this.novaDataSolicitada.hora = moment(this.novaDataSolicitada.dataAgendamento).format('HHmm')
    }

    if (this.novaDataSolicitada.dataAgendamento) {
      const dataSolicitacao = moment(this.novaDataSolicitada.dataAgendamento).format('DDMMYYYYHmm')
      const opcao1 = moment(this.novaDataSolicitada.opcaoDataPrevisto1).format('DDMMYYYYHmm')
      const opcao2 = moment(this.novaDataSolicitada.opcaoDataPrevisto2).format('DDMMYYYYHmm')
      const opcao3 = moment(this.novaDataSolicitada.opcaoDataPrevisto3).format('DDMMYYYYHmm')

      switch (dataSolicitacao) {
        case opcao1:
          this.novaDataSolicitada.opcao = 1
          break

        case opcao2:
          this.novaDataSolicitada.opcao = 2
          break

        case opcao3:
          this.novaDataSolicitada.opcao = 3
          break

        default:
          this.novaDataSolicitada.opcao = 0
          this.novaDataSolicitada.data = moment(this.novaDataSolicitada.dataAgendamento).format('DDMMYYYY')
          this.novaDataSolicitada.hora = moment(this.novaDataSolicitada.dataAgendamento).format('HHmm')
          break
      }
    }
  }

  @Mutation
  setNovaDataSolicitadaSelect(value: string | null) {
    this.novaDataSolicitada.dataAgendamento = value
    this.novaDataSolicitada.opcao = 0

    if (value) {
      const v = moment(value).format('YYYYDDMMHHmm')
      for (let index = 1; index < 4; index++) {
        const data = this.novaDataSolicitada[`opcaoDataPrevisto${index}`]
        const f = moment(data).format('YYYYDDMMHHmm')
        if (v === f) {
          this.novaDataSolicitada.opcao = index
        }
      }
    }
  }

  @Mutation
  setSolicitacao(value: Solicitacao) {
    this.solicitacao = value
  }

  @Mutation
  setAgendamentosMedico(agendamentosCirurgia: AgendamentoCirurgia[]) {
    this.agendamentosCirurgia = agendamentosCirurgia
  }

  @Mutation
  setScrollY(valuey) {
    this.scrollY = valuey
  }

  @Mutation
  setPaciente(paciente: string) {
    this.paciente = paciente
  }

  @Mutation
  setNomePaciente(nome: string) {
    this.solicitacao.nomePaciente = nome
  }

  @Mutation
  setNovaDataSolicitadaFiltro(value: boolean) {
    this.novaDataSolicitadaFiltro = value
  }

  @Mutation
  setConvenioFiltro(value: string[]) {
    this.convenioFiltro = value
  }

  @Mutation
  setPreAnestesiaFiltro(value: string) {
    this.preAnestesiaFiltro = value
  }

  @Mutation
  setOpmeFiltro(value: boolean) {
    this.opmeFiltro = value
  }

  @Mutation
  setDataVirtualFiltro(value: boolean) {
    this.dataVirtualFiltro = value
  }

  @Mutation
  setDataAgendamentoVirtual(value: boolean) {
    this.dataVirtualFiltro = value
  }

  @Mutation
  setSalaVirtual(value: boolean) {
    this.novaDataSolicitada.dataAgendamentoVirtual = value
  }

  @Mutation
  setDataAgendamento(value: string) {
    this.novaDataSolicitada.dataAgendamento = value
  }

  @Mutation
  setTempoCirurgia(value: number) {
    this.solicitacao.tempoCirurgia = value
  }

  @Mutation
  setSalaReservada(value: string) {
    this.solicitacao.salaCirurgicaNome = value
  }

  @Mutation
  clearConvenioFiltro() {
    this.convenioFiltro = []
  }

  @Mutation
  clearPreAnestesiaFiltro() {
    this.preAnestesiaFiltro = ''
  }

  @Mutation
  setNomeMedicoSolicitante(nome: string) {
    this.solicitacao.medicoSolicitante.nome = nome
  }

  @Mutation
  setMedicos(medicos: Medico[]) {
    this.medicos = medicos
  }

  @Mutation
  setMedicoAssistentes(medicos: any[]) {
    this.medicosCadastrados = medicos
  }

  @Mutation
  setMedicoId(value: string) {
    this.medicoId = value
  }

  @Mutation
  setNumeroAgendamento(value: string) {
    this.numeroAgendamento = value
  }

  @Mutation
  setNumeroReserva(value: string) {
    this.novaDataSolicitada.numeroAgendamento = value
  }

  @Mutation
  setOrdenadoPorId(value: string) {
    this.ordenadoPorId = value
  }

  @Mutation
  setEtapaQuery(value: string) {
    this.etapaQuery = value
  }

  @Mutation
  setSituacaoQuery(value: string) {
    this.situacaoQuery.push(value)
  }

  @Mutation
  setStatusAvaliacaoPreAnestesiaQuery(value: string) {
    this.statusAvaliacaoPreAnestesiaQuery.push(value)
  }

  @Mutation
  setSituacoes(situacao: Situacao[]) {
    this.situacoes = situacao
  }

  @Mutation
  setSituacao(situacao: string) {
    const temp: Situacao = {
      display: '',
      key: situacao,
      quantidade: 0,
    }
    this.situacoes.push(temp)
  }

  @Mutation
  setData(value: string) {
    if (this.data.includes(value)) return
    this.data.push(value)
  }

  @Mutation
  setOrderBy(orderBy: string) {
    this.ordenadoPorId = orderBy
  }

  @Mutation
  setVisualizarTriagem(value: boolean) {
    this.visualizarTriagem = value
  }

  @Mutation
  setAcoes(acoes: Acoes) {
    this.acoes = acoes
  }

  @Mutation
  setPagina(value: number) {
    this.pagina = value
  }

  @Mutation
  setQtdPorPagina(value: number) {
    this.qtdPorPagina = value
  }

  @Mutation
  setTotalSolicitacoes(value: number) {
    this.totalSolicitacoes = value
  }

  @Mutation
  setStatusAvaliacaoPreAnestesia(value: StatusAvaliacaoPreAnestesia[]) {
    this.statusAvaliacaoPreAnestesia = value
  }

  @Mutation
  clearAcoes() {
    this.acoes = {
      alterarData: false,
      analizarResposta: false,
      confirmarData: false,
      contatar: false,
      agendamentoRealizaTriagem: false,
      agendamentoAtualizaTriagem: false,
      visualizar: false,
      autorizacaoFazCotacao: false,
      autorizacaoAutorizar: false,
      autorizacaoFazAnalisePreAutorizacao: false,
      autorizacaoFazAnalisePreAutorizacaoUrgencia: false,
      autorizacaoFazAnalisePreCotacao: false,
      autorizacaoAlteraSolicitacaoAutorizada: false,
      autorizacaoEvoluiAguardandoPrazoPosTriagem: false,
      agendamentoConfirmaCancelamento: false,
      visualizarPendencia: false,
      agendamentoFazCancelamento: false,
      autorizacaoSolicitaCancelamento: false,
      anestesistaFazAvaliacao: false,
      autorizacaoAlteraCotacao: false,
    }
  }

  @Mutation
  removeSituacaoQuery(value: string) {
    const removeArray: any[] = []

    for (let i = 0; i < this.situacaoQuery.length; i++) {
      if (this.situacaoQuery[i] === value) {
        removeArray.push(i)
      }
    }

    for (let i = 0; i < removeArray.length; i++) {
      this.situacaoQuery.splice(removeArray[i], 1)
    }
  }

  @Mutation
  removeStatusAvaliacaoPreAnestesiaQuery(value: string) {
    const removeArray: any[] = []

    for (let i = 0; i < this.statusAvaliacaoPreAnestesiaQuery.length; i++) {
      if (this.statusAvaliacaoPreAnestesiaQuery[i] === value) {
        removeArray.push(i)
      }
    }

    for (let i = 0; i < removeArray.length; i++) {
      this.statusAvaliacaoPreAnestesiaQuery.splice(removeArray[i], 1)
    }
  }

  @Mutation
  removeData(value: string) {
    const removeArray: any[] = []

    for (let i = 0; i < this.data.length; i++) {
      if (this.data[i] === value) {
        removeArray.push(i)
      }
    }

    for (let i = 0; i < removeArray.length; i++) {
      this.data.splice(removeArray[i], 1)
    }
  }

  @Mutation
  removeAgendamentoCirurgiaBySolicitacaoId(id: string) {
    const solicitacaoTemp = this.agendamentosCirurgia.filter(p => p.id === id)[0]
    this.agendamentosCirurgia = this.agendamentosCirurgia.filter(p => p.id !== id)

    const situacaoTemp: Situacao[] = []
    this.situacoes.map((s) => {
      const temp = s

      if (temp.key === solicitacaoTemp.situacao.key) {
        temp.quantidade -= 1
      }
      situacaoTemp.push(temp)
      return temp
    })

    this.situacoes = situacaoTemp
  }

  @Mutation
  removeConvenioFiltro(value: string) {
    const index = this.convenioFiltro.indexOf(value)
    if (index >= 0) this.convenioFiltro.splice(index, 1)
  }

  @Mutation
  setHeaderStatusFiltro(value: HeaderStatusFiltro) {
    this.headerStatusFiltro = value
  }

  @Mutation
  setConvenios(value: Convenio[]) {
    this.convenios = value
  }

  @Mutation
  clearFiltro() {
    this.ordenadoPorId = 'DataUltimaInteracaoAsc'
    this.paciente = ''
    this.medicoId = ''
    this.numeroAgendamento = ''
    this.novaDataSolicitadaFiltro = false
    this.novaDataSolicitada = { ...this.novaDataSolicitadaDefault }
    this.dataVirtualFiltro = false
    this.convenioFiltro = []
    this.preAnestesiaFiltro = ''
    this.opmeFiltro = false
  }

  @Mutation
  clearQueryAll() {
    this.situacaoQuery = []
    this.paciente = ''
    this.medicoId = ''
    this.ordenadoPorId = 'DataUltimaInteracaoAsc'
    this.data = []
    this.novaDataSolicitadaFiltro = false
    this.convenioFiltro = []
    this.preAnestesiaFiltro = ''
    this.dataVirtualFiltro = false
    this.pagina = this.paginaDefault
    this.qtdPorPagina = this.qtdPorPaginaDefault
    this.statusAvaliacaoPreAnestesiaQuery = []
    this.opmeFiltro = false
  }

  @Mutation
  clearPagination() {
    this.pagina = this.paginaDefault
    this.qtdPorPagina = this.qtdPorPaginaDefault
  }

  @Mutation
  clearNovaDataSolicitada() {
    this.novaDataSolicitada = { ...this.novaDataSolicitadaDefault }
  }

  @Mutation
  clearHeaderStatusFiltro() {
    this.headerStatusFiltro = { ...this.headerStatusFiltroDefault }
  }

  @Mutation
  clearSolicitacao() {
    this.solicitacao = this.solicitacaoDefault
  }

  @Mutation
  clearReservaHemocomponentes() {
    this.reservaHemocomponentes = {
      concentradoHemacias: {
        quantidade: null,
        value: false,
      },
      concentradoPlaquetas: {
        quantidade: null,
        value: false,
      },
      crioprecipitado: {
        quantidade: null,
        value: false,
      },
      plasmaFrescoCongelado: {
        quantidade: null,
        value: false,
      },
      tipagemSanguinea: {
        value: false,
      },
      tipagemSanguineaABORHPAI: {
        quantidade: null,
        value: false,
      },
      semReserva: {
        quantidade: null,
        value: false,
      },
    }
  }

  @Mutation
  clearAgendamentosCirurgia() {
    this.agendamentosCirurgia = []
  }

  @Mutation
  setCotacaoOperadorasExtraGrupoValor(value: number | null) {
    if (this.solicitacao.cotacaoOperadorasExtraGrupo) this.solicitacao.cotacaoOperadorasExtraGrupo.valor = value
  }
}
